module.exports = __webpack_public_path__ + "assets/a514a425ac521d8c43d9d1297c255abf.mp3";